module.exports = __webpack_public_path__ + "img/ms-icon-144x144.51879ed.png";